import { defineStore } from 'pinia'
import Sws from '@serato/sws-sdk'
import * as SentryBrowser from '@sentry/browser'

export declare interface State {
  avatar: string,
  isLoggedIn: boolean,
  userId: number | null,
  canGenerateImages: boolean
}
export type Avatar = {
  ts: number;
  thumb: string;
  mid: string;
  full: string;
};
export type Profile = {
  user_id: number;
  email_address: string;
  avatar?: Avatar;
};
export const useEndUserProfileStore = defineStore('endUserProfileStore', {
  state: (): State => ({
    avatar: '',
    isLoggedIn: false,
    userId: null,
    canGenerateImages: false
  }),
  actions: {
    async fetchProfile (sws: Sws): Promise<void> {
      const profile = await sws.profile.getProfile()
      this.avatar = profile.avatar && profile.avatar.thumb ? profile.avatar.thumb : ''
      this.isLoggedIn = profile.user_id ? true : false
      this.userId = profile.user_id
      SentryBrowser.setUser({ 'id': String(profile.user_id) })
      this.getProviderStatus(sws)
    },
    async getProviderStatus (sws: Sws, provider = 'OpenAI'): Promise<void> {
      try {
        const status = await sws.aiproxy.getProviderStatus({ provider })
        this.canGenerateImages = status.eligibility.generate_images
      } catch (e) {
        console.error(e)
      }
    }
  }
})
